<template>
  <div>
    <h2> Client Details </h2>

    <div class="alert alert-warning" v-if='isFonterraClient'>
      <strong>
        This client is eligible for Fonterra's Cooperative animal wellbeing plan
      </strong>
      <p>
      Please ensure the clients supply number(s) are correct and animal numbers fields are completed
      </p>
      <check-box label="Client wants a CD well-being plan"
                 :disabled="isReadOnly"
                 field-name="wants_cd_wellbeing_plan">
      </check-box>
    </div>

    <text-input label="Client Code"
                field-name="client_code"
                :disabled="true">
    </text-input>

    <text-input label="Company"
                field-name="company"
                :disabled="true">
    </text-input>

    <text-input label="Name"
                field-name="full_name"
                :disabled="true">
    </text-input>

    <text-input label="Farm Group Name"
                field-name="farm_group_name"
                :disabled="true">
    </text-input>

    <text-input label="Previous Consult Year"
                field-name="previous_winter_consult_year"
                :disabled="true">
    </text-input>

    <text-input label="Zone"
                field-name="zone"
                :disabled="true">
    </text-input>

    <text-input label="Email Notification Zone"
                field-name="email_notification_zone"
                disabled>
    </text-input>

    <text-input label="Keyvets"
                field-name="vision_keyvets"
                :disabled="true">
    </text-input>

    <text-area label="Tags"
                field-name="tags"
                :disabled="true">
    </text-area>

  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import baseComponent from '@/mixins/base_consult_component_v2'

export default {
  name: 'ClientDetails',
  mixins: [ baseComponent ],
  computed:
  {
    ...mapGetters('currentConsult', [
      'isFonterraClient',
    ]),
  }
};
</script>
